/* eslint-disable tailwindcss/no-arbitrary-value */
import { FC } from 'react';
import { ProductHeroKeyStat } from '../../productHero';

type FlexibleHeroBlockStkBkaKeyStatsProps = {
  keyStats: ProductHeroKeyStat[];
};

/** The editor-picked key stats as a two-column grid in the side card. */
export const FlexibleHeroBlockStkBkaKeyStats: FC<
  FlexibleHeroBlockStkBkaKeyStatsProps
> = ({ keyStats }) => (
  <dl
    className="grid w-full grid-cols-2 gap-3 rounded-radius/table p-4 bg-fill/alternative-1"
    data-component="flexible-hero-block-stk-bka-key-stats"
  >
    {keyStats.map(({ key, label, primaryValue, secondaryValue }) => (
      <div key={key} className="flex flex-col gap-[--spacing-half]">
        <dt className="mhg-alpha-typography-table-cell-norm-medium text-secondary-lighter">
          {label}
        </dt>
        <dd className="mhg-alpha-typography-table-cell-strong text-text/accent">
          {[primaryValue, secondaryValue].filter(Boolean).join(' ')}
        </dd>
      </div>
    ))}
  </dl>
);
